import { render, staticRenderFns } from "./EditPruning.vue?vue&type=template&id=08892cdc&scoped=true&lang=html&"
import script from "./EditPruning.vue?vue&type=script&lang=js&"
export * from "./EditPruning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08892cdc",
  null
  
)

export default component.exports